import React from "react";

import { ForgotPasswordService } from "./services/ForgotPassword.service";
import { ForgotPasswordView } from "./views/ForgotPasswordView";
import dependencyInjection from "../../../common/util/dependencyInjection";

interface Services {
  forgotPasswordService: ForgotPasswordService;
}

const forgotPasswordService = new ForgotPasswordService();

const [ForgotPasswordDependencyProvider, useForgotPasswordDeps] = dependencyInjection<Services>({
  services: { forgotPasswordService },
});

const ForgotPasswordPage = () => (
  <ForgotPasswordDependencyProvider>
    <ForgotPasswordView />
  </ForgotPasswordDependencyProvider>
);

export { ForgotPasswordPage, useForgotPasswordDeps };
